import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Dialog } from '@mui/material';
import { IProps, IStateProps, IDispatchProps } from './interfaces';
import { clearStorageSummary } from '../../../state/storageSummary';
import { IAppState } from '../../../state/reducers';
import StorageSummary from './StorageSummary/storageSummary';

class StorageSummaryDialog extends PureComponent<IProps> {
  render() {
    const {
      isOpen,
      onClose,
    } = this.props;

    return (
      <Dialog
        open={isOpen}
        onClose={onClose}
        fullWidth
        maxWidth="md"
      >
        <StorageSummary />
      </Dialog>
    );
  }
}

const mapStateToProps = (state: IAppState): IStateProps => ({
  isOpen: state.storageSummary.isOpen,
});

const mapDispatchToProps: IDispatchProps = {
  onClose: clearStorageSummary,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(StorageSummaryDialog);
